import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, Sparkles } from 'lucide-react';
export function UrgencyBanner() {
  const [spotsTaken] = useState(94);
  const [timeLeft, setTimeLeft] = useState({
    h: 22,
    m: 40,
    s: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-brand-purpleDark via-brand-purple to-brand-purpleDark text-white shadow-md border-b border-brand-gold/30" data-id="element-390" data-mp="1bv534qz21hzc">
      <div className="max-w-7xl mx-auto px-3 py-2 md:px-6 md:py-2.5" data-id="element-391" data-mp="1gwc9qmpgob4f">
        {/* Mobile marquee */}
        <div className="md:hidden overflow-hidden relative" data-id="element-392" data-mp="27gt0x5rouq6s">
          <motion.div className="flex items-center gap-6 whitespace-nowrap text-[11px] font-medium w-max" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 18,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-393" data-mp="22n7z12mz5c2b">
            {[0, 1].map(dup => <div key={dup} className="flex items-center gap-6 shrink-0" data-id="element-394" data-mp="2qdu7gv0w4ycu">
                <div className="flex items-center gap-1.5 shrink-0 text-brand-goldLight" data-id="element-395" data-mp="2lehju8273n97">
                  <Clock className="w-3.5 h-3.5 shrink-0" data-id="element-396" data-mp="2lco9oisdikwg" />
                  <span data-id="element-397" data-mp="2gdtk8xzwhy3d">Precio de lanzamiento cierra en</span>
                  <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-398" data-mp="2cecd804tssw3">
                    {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-399" data-mp="10x2xnootil02" />
                <div className="flex items-center gap-1.5 shrink-0" data-id="element-400" data-mp="12h4hnbyu86go">
                  <Sparkles className="w-3.5 h-3.5 shrink-0 animate-pulse text-brand-goldLight" data-id="element-401" data-mp="17ffsnq0vcn0h" />
                  <span data-id="element-402" data-mp="si5a5wpt6gv9">
                    <strong className="tabular-nums text-brand-goldLight" data-id="element-403" data-mp="sgu41q8w4x0z">
                      {spotsTaken}%
                    </strong>{' '}
                    de cupos tomados
                  </span>
                </div>
                <span className="w-1 h-1 rounded-full bg-brand-goldLight/50 shrink-0" data-id="element-404" data-mp="jn8q294jvjsm" />
                <a href="#pricing" className="inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-bold px-2.5 py-0.5 rounded-full text-[11px] shrink-0" data-id="element-405" data-mp="ohlekxkvvlb8">
                  Ver kit →
                </a>
              </div>)}
          </motion.div>
        </div>

        {/* Desktop */}
        <div className="hidden md:flex items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm font-medium" data-id="element-406" data-mp="r95hjdwjij2">
          <div className="flex items-center gap-1.5 md:gap-2 whitespace-nowrap text-brand-goldLight" data-id="element-407" data-mp="4tvqp1g2i57a">
            <Clock className="w-3.5 h-3.5 md:w-4 md:h-4 shrink-0" data-id="element-408" data-mp="3da1tntv74icw" />
            <span className="hidden sm:inline" data-id="element-409" data-mp="3dbms3ukmslg1">
              Precio de lanzamiento cierra en
            </span>
            <span className="sm:hidden" data-id="element-410" data-mp="3r7qdqzhfvlgw">Cierra en</span>
            <span className="font-mono font-bold tabular-nums bg-white/15 rounded px-1.5 py-0.5 ml-0.5 text-white" data-id="element-411" data-mp="3m9owmk3kpw82">
              {fmt(timeLeft.h)}:{fmt(timeLeft.m)}:{fmt(timeLeft.s)}
            </span>
          </div>
          <div className="hidden md:block w-px h-4 bg-brand-goldLight/40 shrink-0" data-id="element-412" data-mp="2qkde8zwcly" />
          <div className="hidden md:flex items-center gap-2 whitespace-nowrap" data-id="element-413" data-mp="dtvgw7h2gos2">
            <Sparkles className="w-4 h-4 shrink-0 animate-pulse text-brand-goldLight" data-id="element-414" data-mp="9stgvofbs8p1" />
            <span data-id="element-415" data-mp="nsuornu0cge0">
              <strong className="tabular-nums text-brand-goldLight" data-id="element-416" data-mp="nsbaqi7hac59">
                {spotsTaken}%
              </strong>{' '}
              de cupos tomados
            </span>
          </div>
          <a href="#pricing" className="hidden sm:inline-flex items-center gap-1 bg-brand-goldLight text-brand-purpleDark font-bold px-3 py-1 rounded-full text-[11px] md:text-xs hover:bg-white transition-colors shrink-0" data-id="element-417" data-mp="12wnoqu6z4qgp">
            Ver kit →
          </a>
        </div>
      </div>
    </div>;
}